/**
 * Cookiebot consent — treat the "X" (close/dismiss) control as "Allow all".
 *
 * Business requirement: clicking the banner's X = the same outcome as the
 * "Allow all" button (accept every category and close the banner).
 *
 * Approach: a capture-phase click listener that fires BEFORE Cookiebot's own
 * handler. When the click lands on the close "X", we find the real "Allow all"
 * button and click it (that one action both accepts everything AND closes the
 * banner). Only then do we cancel the native close.
 *
 * If — for any reason — the "Allow all" button can't be found, we DON'T cancel
 * the native close, so the banner can always still be dismissed (never stuck).
 *
 * The genuine action buttons (Deny / Customize / Allow selection / Allow all)
 * are never matched as "the X", so their normal behaviour is preserved.
 */
(function () {
  'use strict';

  // The close/dismiss "X" across Cookiebot templates.
  var CLOSE_SELECTOR = [
    '.CybotCookiebotBannerCloseButton',
    '.CybotCookiebotDialogClose',
    '.CookiebotWidget-close',
    '[aria-label="Close banner"]',
    '[aria-label="Close"]'
  ].join(',');

  // Genuine action buttons — never treat these as the "X".
  var ACTION_SELECTOR = [
    '#CybotCookiebotDialogBodyButtonDecline',
    '#CybotCookiebotDialogBodyButtonDetails',
    '#CybotCookiebotDialogBodyLevelButtonCustomize',
    '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection',
    '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll',
    '#CybotCookiebotDialogBodyButtonAccept',
    '#CybotCookiebotDialogBodyButtonAcceptAll'
  ].join(',');

  // Known IDs for the "Allow all" button across templates.
  var ALLOW_ALL_IDS = [
    'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll',
    'CybotCookiebotDialogBodyButtonAcceptAll',
    'CybotCookiebotDialogBodyButtonAccept',
    'CybotCookiebotBannerButtonAcceptAll'
  ];

  // Text/aria patterns identifying an "Allow all" / "Accept all" control.
  var ALLOW_ALL_TEXT = /^(allow all|accept all|allow selection all|tillad alle)$/i;

  function findAllowAllButton() {
    // 1) Try the well-known IDs first.
    for (var i = 0; i < ALLOW_ALL_IDS.length; i++) {
      var byId = document.getElementById(ALLOW_ALL_IDS[i]);
      if (byId) return byId;
    }
    // 2) Fall back to matching button/link text or aria-label.
    var candidates = document.querySelectorAll(
      '#CybotCookiebotDialog button, #CybotCookiebotDialog a,' +
      '[class*="CybotCookiebot"] button, [class*="CybotCookiebot"] a'
    );
    for (var j = 0; j < candidates.length; j++) {
      var el = candidates[j];
      if (el.closest(CLOSE_SELECTOR)) continue; // skip the X itself
      var label = ((el.getAttribute && el.getAttribute('aria-label')) || '').trim();
      var text = (el.textContent || '').trim();
      if (ALLOW_ALL_TEXT.test(label) || ALLOW_ALL_TEXT.test(text)) return el;
    }
    return null;
  }

  function onClickCapture(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    // Ignore clicks on the genuine action buttons.
    if (target.closest(ACTION_SELECTOR)) return;

    // Only act when the click is on a close/dismiss control.
    if (!target.closest(CLOSE_SELECTOR)) return;

    var allowAll = findAllowAllButton();
    if (allowAll) {
      // Replace the close with an "Allow all" click (accepts all + closes).
      e.preventDefault();
      e.stopImmediatePropagation();
      allowAll.click();
      return;
    }

    // Fallback: try the API, but let the native close still run so the banner
    // is never left stuck open.
    try {
      if (window.Cookiebot && typeof window.Cookiebot.submitCustomConsent === 'function') {
        window.Cookiebot.submitCustomConsent(true, true, true);
      }
    } catch (err) { /* let the native close proceed */ }
  }

  // Capture phase so we run before Cookiebot's bubbling handlers.
  document.addEventListener('click', onClickCapture, true);
})();
